import React from 'react';

import { Box, Button, ButtonProps, Tooltip } from '@mui/material';

type ExtendedButtonType = ButtonProps & {
  text?: string | React.ReactNode;
  width?: string;
  toolTip?: string;
  customSx?: object;
  height?: string;
  parentSx?: object;
  testid?: string;
};

const CustomButton = ({
  variant,
  text,
  endIcon,
  width,
  toolTip,
  disabled,
  type,
  onClick,
  height,
  testid,
  customSx,
  parentSx,
}: ExtendedButtonType) => {
  const getWidth = () => {
    switch (width) {
      case 'small':
        return '32px';
      case 'medium':
        return '132px';
      case 'large':
        return '162px';
      default:
        return width;
    }
  };

  return (
    <Box sx={{ width: width, cursor: disabled ? 'not-allowed' : 'pointer', ...parentSx }}>
      <Tooltip
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
          ],
        }}
        title={toolTip || ''}>
        <span>
          <Button
            data-testid={testid}
            disabled={disabled || false}
            type={type}
            variant={variant}
            endIcon={endIcon}
            onClick={(e) => onClick && onClick(e)}
            onMouseUp={(e) => e.currentTarget.blur()}
            sx={{
              width: getWidth(),
              minWidth: getWidth(),
              height: height ? height : '32px',
              padding: '8px 14px 8px 14px',
              boxShadow: 'none',
              '@media print': {
                display: 'none',
              },
              ...customSx,
            }}>
            {text}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default CustomButton;
